import Api from '@utils/api';
import { BancosDePreguntas } from '@constants/urls';

export const state = {
	bancosDePreguntas: [],
	bancoDePreguntas: {},
	pregunta: {},
	filtro: '',
	loading: false,
	loading_action: false
};

export const getters = {
	getBancosDePreguntas(state) {
		return state.bancosDePreguntas;
	},
	getBancoDePreguntas(state) {
		return state.bancoDePreguntas;
	},
	getPregunta(state) {
		return state.pregunta;
	},
	getLoading(state) {
		return state.loading;
	},
	getLoadingAction(state) {
		return state.loading_action;
	}
};

export const mutations = {
	SET_BANCOS_DE_PREGUNTAS(state, newValue) {
		state.bancosDePreguntas = newValue;
	},
	SET_BANCO_DE_PREGUNTAS(state, newValue) {
		state.bancoDePreguntas = newValue;
	},
	SET_PREGUNTA(state, newValue) {
		state.pregunta = newValue;
	},
	SET_LOADING_FILES(state, newValue) {
		state.loading_action = newValue;
	},
	SET_FILTRO(state, newValue) {
		state.filtro = newValue;
	},
	SET_LOADING(state, newValue) {
		state.loading = newValue;
	}
};

export const actions = {
	inicializar({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(BancosDePreguntas.LISTAR)
			.then((response) => {
				commit('SET_BANCOS_DE_PREGUNTAS', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerBancosDePreguntas({ commit }, { onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(BancosDePreguntas.LISTAR)
			.then((response) => {
				commit('SET_BANCOS_DE_PREGUNTAS', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerBancoDePreguntas({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(BancosDePreguntas.OBTENER(clave))
			.then((response) => {
				commit('SET_BANCO_DE_PREGUNTAS', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	establecerBancoDePreguntas({ commit }, bancoDePreguntas) {
		commit('SET_BANCO_DE_PREGUNTAS', bancoDePreguntas);
	},
	establecerPregunta({ commit }, pregunta) {
		commit('SET_PREGUNTA', pregunta);
	},
	establecerFiltro({ commit }, { filtro }) {
		commit('SET_FILTRO', filtro);
	},
	subirArchivoDocx({ commit }, { archivos, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(BancosDePreguntas.IMPORTAR, archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodos({ commit }, { onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(BancosDePreguntas.ELIMINAR_TODOS)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	crearBancoDePreguntas({ commit }, { params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Post(BancosDePreguntas.CREAR, params)
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	editarEncabezado({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(BancosDePreguntas.EDITAR_ENCABEZADO(clave), params)
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => {
				commit('SET_LOADING_FILES', false);
			});
	},
	eliminarBancoDePreguntas({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(BancosDePreguntas.ELIMINAR(clave))
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	crearPregunta({ commit }, { clave, data, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Post(BancosDePreguntas.CREAR_PREGUNTA(clave), data)
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	editarPregunta({ commit }, { clave, data, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(BancosDePreguntas.EDITAR_PREGUNTA(clave), data)
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => {
				commit('SET_LOADING_FILES', false);
			});
	},
	eliminarPregunta({ commit }, { clave, data, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(BancosDePreguntas.ELIMINAR_PREGUNTA(clave), { data })
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	}
};
